import React from 'react';

import findMaxFontSizeWithoutOverflow from '../../tools/StickyTool/findMaxFontSizeWithoutOverflow';
import useStatusChange from '../ReactContainer/useStatusChange';

import { ActivityIndicator } from './ActivityIndicator';
import useTimeseriesLatestValue from './useTimeseriesLatestValue';

export type TimeseriesValueContentInterface = {
  useStatusChange: typeof useStatusChange;
  useTimeseriesLatestValue: (
    ...args: Parameters<typeof useTimeseriesLatestValue>
  ) => Pick<
    ReturnType<typeof useTimeseriesLatestValue>,
    'data' | 'isLoading' | 'isFetching' | 'isError'
  >;
  findMaxFontSizeWithoutOverflow: typeof findMaxFontSizeWithoutOverflow;
  ActivityIndicator: typeof ActivityIndicator;
};

export const TimeseriesValueContentContext =
  React.createContext<TimeseriesValueContentInterface>({
    useStatusChange,
    useTimeseriesLatestValue,
    findMaxFontSizeWithoutOverflow,
    ActivityIndicator,
  });
